import React, { useEffect, useState } from 'react'
import TopNavbar from '../../CommonComponent/topNavbar/TopNavbar'
import Sidebar from '../../CommonComponent/sidebar/Sidebar'
import { Col, Form, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { SmBidReg, SecondryMarketSMgetAuctionById } from '../../redux/auth-reducer/auth-service'
import { ImageUrl } from '../../utils/config/config'
import { lastBidField, listingKey } from '../../utils/helper/auctionGrid'
import { listingBidBody, listingLevel, pickListingFigures, readListingReply } from '../../utils/helper/lotPage'
import { bidTimeLabel } from '../../utils/helper/auctionForm'
import { useLotPage } from './useLotPage'
import {
    BidAction,
    CustomBidField,
    LotClockPanel,
    LotField,
    LotResultModal,
    MinimumNextBid,
} from './LotPageParts'

const PUSH_EVENTS = ['ReceiveSMBidStatus', 'ReceiveCurrentSMBid'];
const EXIT_TO = "/Player/Secondary_Market";
const LISTING_UNKNOWN_MESSAGE = 'This listing could not be identified. Please open it again from the Secondary Market.';

const SecodaryPlaceBidPage = () => {

    const [data, setData] = useState(false);
    const [bidAmount, setBidAmount] = useState('');
    const { state } = useLocation()
    const navigate = useNavigate()

    // The listing's figures, clock and close - the same as PlaceBid's (useLotPage). Its reload is
    // SecondaryMarket/SMGetAuctionById. The page used to keep its own minutes and seconds, saved them
    // to localStorage ('timerState') and read them back on the next listing it opened, started a
    // listing it knew nothing about at 5:00, and treated a '00:01' it was handed as a full BidTime.
    const page = useLotPage({
        lot: state,
        // A team can have a level-1 and a level-2 listing at once; only this one's rows count.
        // Pushes used to be matched by auction and team alone, so the other listing's clock and
        // figures landed here.
        isThisRow: (row) => listingKey(row) === listingKey(state),
        pickFigures: pickListingFigures,
        load: () => SecondryMarketSMgetAuctionById(state).then(readListingReply),
        pushEvents: PUSH_EVENTS,
        // usp_InsertSMBidModel refuses with a message only, no errorCode.
        closedCodes: [],
        exitTo: EXIT_TO,
    });
    const { figures } = page;

    const sidebarfun = () => {
        setData(!data)
    }

    const handleSubmit = async () => {
        // #184 (reopened): a bid must name the listing on screen, or the server cannot tell which
        // round it is for and refuses it. The Secondary Market row always carries it; a page opened
        // without one sends nothing.
        if (listingLevel(state) === null) {
            toast.error(LISTING_UNKNOWN_MESSAGE, { toastId: 'lot-bid-listing-unknown' });
            return;
        }
        const accepted = await page.submitBid(SmBidReg, listingBidBody(state, figures, bidAmount));
        if (accepted) setBidAmount('');
    };

    // #176: "Start Bid" or "Last Bid", and its amount, from the figures shown.
    const lastBid = lastBidField(figures ?? state);
    // The share the winner receives - fixed by the listing, not chosen by the bidder.
    const share = figures?.ownerShipShare ?? state?.ownerShipShare;

    return (
        <>

            <LotResultModal show={page.ended} won={page.wonLot} onHide={() => navigate(EXIT_TO)} />

            <TopNavbar sidebarfun={sidebarfun} />
            <div className="dasboard-group" >
                <Sidebar data={data} />
                <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>

                    <Row>
                        <Col md={6}><h1 className="heading-dash">  Place Bid </h1></Col>
                    </Row>
                    <div className='group_data_table p-3'>
                        <Row>
                            <Col md={6}>

                                <Form noValidate>
                                    <LotField md="12 mt-3" className="text-left " labelClassName="" label="Team" name="teamId" value={figures?.teamName} />
                                    <Row>
                                        <LotField md="6 mt-3" label={`  ${lastBid.label}`} name="minBid" value={lastBid.amount} />
                                        <LotField md="6 mt-3" label="Bid Time Limit" name="bidTimeLimit" value={bidTimeLabel(figures?.bidTime)} />
                                        <LotField md="6 mt-3" label="Total Placed Bids" name="bidPlacedBy" value={figures?.totalPlacedBids} />
                                        <LotField md="6 mt-3" label="Minimum Bid Increment" name="bidIncrement" value={state?.bidIncrement} />
                                        <LotField md="6 mt-3" label="Share Offered" name="ownerShipShare" value={share ? `${share}%` : "-"} />
                                        <LotField md="6 mt-3" label="Highest Bidder" name="bidPlacedByName" value={figures?.bidPlacedByName || "No bids yet"} />

                                        <MinimumNextBid amount={figures?.currentBidAmount} />
                                        <CustomBidField value={bidAmount} onChange={setBidAmount} />

                                        <Form.Group as={Col} md="5">
                                            <BidAction
                                                loading={page.submitting || !page.lot}
                                                hidden={isNaN(figures?.startingBid)}
                                                canBid={page.canBid}
                                                onBid={handleSubmit}
                                                isHighBidder={page.isHighBidder}
                                            />
                                        </Form.Group>
                                    </Row>
                                </Form>

                                <div className='border-right'></div>
                            </Col>
                            <Col md={6}>
                                <div className='placeBid-sec'>
                                    <h2 className='text-white'>
                                        {state?.auctionName}
                                        - {state?.teamName}
                                    </h2>
                                    {
                                        state?.teamImage == null ? <img src='/image/team-icon.png' width={100} alt=''></img> : <img src={ImageUrl + state?.teamImage} width={100} alt=''></img>
                                    }

                                    <LotClockPanel ended={page.ended} lot={page.lot} seconds={page.seconds} countdownText={page.countdownText} />

                                    {
                                        state?.auctionImage == null ? <img src="../image/auctionImage.png" className='ImageAuction_bid' alt='' /> : <img src={ImageUrl + state?.auctionImage} className='img-fluid' width={200} alt=''></img>
                                    }
                                </div>
                            </Col>
                        </Row>

                    </div>

                </div>
            </div>
        </>
    )
}

/**
 * FE-14 QA (row 1656): opened from the Secondary Market, which hands the page the listing in the
 * router state. Without one (a pasted link) it goes back to the Secondary Market instead of sending
 * its requests for an undefined listing.
 */
export const SecodaryPlaceBid = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const missing = state?.auctionId == null || state?.teamId == null;

    useEffect(() => {
        if (missing) navigate(EXIT_TO, { replace: true });
    }, [missing, navigate]);

    return missing ? null : <SecodaryPlaceBidPage />;
};
